import type { SVGProps } from 'react';

const SvgBugMarkFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 266 178" {...props}>
    <path fill={props.color} d="M266 178H0V0h266l-55.835 89L266 178Z" />
  </svg>
);

export default SvgBugMarkFilled;
